































































import Vue from 'vue'
import SvgImage from '~/components/SvgImage.vue'

export default Vue.extend({
  components: {
    SvgImage
  },
  props: {
    urlToShare:
    {
      type: String,
      default: ''
    },
    mailSubject:
    {
      type: String,
      default: ''
    },
    mailBody:
    {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showSocialIcons: false
    }
  },
  methods: {
    shareClick () {
      this.showSocialIcons = true
    }
  }
})
